import * as tiresServices from './tiresServices';

export { tiresServices };
